import { useQuery } from '@tanstack/react-query'
import { PublicCourseGroupWithBookingInfoEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetCourseGroupsPublic(courseId: string): {
  courseGroups: PublicCourseGroupWithBookingInfoEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
} {
  const {
    data: courseGroups,
    isLoading,
    isError,
  } = useQuery(GetCourseGroupsPublicQueryKey(courseId), async () => {
    return qoursesApi.coursePublic.coursePublicControllerGetCourseGroupsV1(courseId)
  })

  let isEmpty = true

  if (courseGroups === undefined) {
    return { courseGroups: [], isLoading, isEmpty, isError }
  }

  if (courseGroups.length > 0) {
    isEmpty = false
  }

  return { courseGroups, isLoading, isEmpty, isError }
}

export const GetCourseGroupsPublicQueryKey = (courseId: string) => [
  'public',
  'courseGroups',
  courseId,
]
